import React, { useRef, useState } from "react";
import { Box, IconButton, Dialog, DialogContent } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const CustomImageUploader = ({ value = [], onChange, onDeleteImage, onViewImage }) => {
  const fileInputRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => ({
      file: file,
      preview: URL.createObjectURL(file),
    }));
    onChange([...value, ...newImages]);
  };

  const handleDelete = (index) => {
    const image = value[index];
    if (onDeleteImage && image) {
      // Truyền object ảnh đầy đủ cho callback xóa (API backend cần object)
      onDeleteImage(image);
    } else {
      const newImages = value.filter((_, i) => i !== index);
      onChange(newImages);
    }
  };

  const handleView = (img) => {
    if (onViewImage) {
      onViewImage(img);
    } else {
      setPreviewImage(img);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 2, marginTop: 3, flexWrap: "wrap" }}>
        {value.map((img, index) => (
          <Box
            key={index}
            sx={{
              width: 200,
              height: 200,
              borderRadius: "8px",
              overflow: "hidden",
              border: "2px solid #ccc",
              position: "relative",
              "&:hover .image-actions": { opacity: 1, visibility: "visible" },
            }}
          >
            <img
              src={
                img.preview ||
                (img.file ? URL.createObjectURL(img.file) : img.url)
              }
              alt={`image-${index}`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <Box
              className="image-actions"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                opacity: 0,
                visibility: "hidden",
                transition: "opacity 0.3s ease",
              }}
            >
              <IconButton
                onClick={() => handleView(img)}
                sx={{ color: "#fff" }}
              >
                <VisibilityIcon />
              </IconButton>
              <IconButton
                onClick={() => handleDelete(index)}
                sx={{ color: "#fff" }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        ))}
        <input
          type="file"
          ref={fileInputRef}
          accept="image/*"
          multiple
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <IconButton
          sx={{
            width: 200,
            height: 200,
            borderRadius: "8px",
            border: "2px dashed #4CAF50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(76, 175, 80, 0.1)",
          }}
          onClick={() => fileInputRef.current.click()}
        >
          <AddPhotoAlternateIcon sx={{ fontSize: 40, color: "#4CAF50" }} />
        </IconButton>
      </Box>

      {/* Image Preview Dialog */}
      <Dialog
        open={!!previewImage}
        onClose={() => setPreviewImage(null)}
        maxWidth="sm"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              previewImage?.preview ||
              (previewImage?.file
                ? URL.createObjectURL(previewImage.file)
                : previewImage?.url)
            }
            alt="Preview"
            style={{ width: "80%", height: "auto", borderRadius: "8px" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CustomImageUploader;
